import { render, staticRenderFns } from "./system_notice_list.vue?vue&type=template&id=8e922d80&scoped=true"
import script from "./system_notice_list.vue?vue&type=script&lang=js"
export * from "./system_notice_list.vue?vue&type=script&lang=js"
import style0 from "./system_notice_list.vue?vue&type=style&index=0&id=8e922d80&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e922d80",
  null
  
)

export default component.exports